import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const THEME_STORAGE_KEY = 'crm-ui-theme';

export const UI_THEMES = {
  CLASSIC: 'classic',
  MODERN: 'modern',
};

const ThemeContext = createContext({
  theme: UI_THEMES.CLASSIC,
  setTheme: () => {},
  toggleTheme: () => {},
});

const readInitialTheme = () => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === UI_THEMES.MODERN || stored === UI_THEMES.CLASSIC) {
      return stored;
    }
  } catch (_) {}
  // Domyślnie klasyczny wygląd – nie zmieniamy dotychczasowego UI bez decyzji użytkownika.
  return UI_THEMES.CLASSIC;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(readInitialTheme);

  const setTheme = useCallback((next) => {
    const value = next === UI_THEMES.MODERN ? UI_THEMES.MODERN : UI_THEMES.CLASSIC;
    setThemeState(value);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, value);
    } catch (_) {}
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme(theme === UI_THEMES.MODERN ? UI_THEMES.CLASSIC : UI_THEMES.MODERN);
  }, [theme, setTheme]);

  const value = useMemo(() => ({ theme, setTheme, toggleTheme }), [theme, setTheme, toggleTheme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
